import { render, staticRenderFns } from "./FetalInsurance.vue?vue&type=template&id=240480f8&"
import script from "./FetalInsurance.vue?vue&type=script&lang=js&"
export * from "./FetalInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports